export default "__VITE_ASSET__BgcPbEw2__"